import React, { SVGProps } from 'react';

/**
 * viewBox='0 0 24 24' er den faktiske størrelsen på svg'en. De to siste veridene må være svgen sin
 * faktiske bredde og høyde. Hvis ikke vil svg'en bli strukket til å fylle hele plassen den har.
 * widt og height er satt til 100% for å fylle hele plassen den har.
 * @param props
 * @constructor
 */
interface SvgProps extends SVGProps<SVGSVGElement> {
	pathFill?: string;
	color?: string;
}

export const AndelTunge: React.FC<SvgProps> = ({ pathFill = 'white', ...props }) => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 16 16'
			fill={pathFill}
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<g id='Ikon'>
				<path
					id='Vector'
					d='M8.8 2.8001C9.02 2.8001 9.2 2.9801 9.2 3.2001V10.4001C9.2 10.6201 9.02 10.8001 8.8 10.8001H8H6.08C5.665 10.0826 4.89 9.6001 4 9.6001C3.11 9.6001 2.335 10.0826 1.92 10.8001H1.6C1.38 10.8001 1.2 10.6201 1.2 10.4001V3.2001C1.2 2.9801 1.38 2.8001 1.6 2.8001H8.8ZM9.6 12.0001C9.6 13.3251 10.675 14.4001 12 14.4001C13.325 14.4001 14.4 13.3251 14.4 12.0001H15.4C15.7325 12.0001 16 11.7326 16 11.4001C16 11.0676 15.7325 10.8001 15.4 10.8001H15.2V7.7326C15.2 7.3601 15.0525 7.0051 14.79 6.7426L12.4575 4.4101C12.195 4.1476 11.84 4.0001 11.4675 4.0001H10.4V3.2001C10.4 2.3176 9.6825 1.6001 8.8 1.6001H1.6C0.7175 1.6001 0 2.3176 0 3.2001V10.4001C0 11.2826 0.7175 12.0001 1.6 12.0001C1.6 13.3251 2.675 14.4001 4 14.4001C5.325 14.4001 6.4 13.3251 6.4 12.0001H8H8.8H9.4H9.6ZM13.9425 7.5901C13.945 7.5926 13.95 7.5976 13.9525 7.6001H10.4V5.2001H11.4675C11.52 5.2001 11.5725 5.2201 11.61 5.2576L13.9425 7.5901ZM2.8 12.0001C2.8 11.6818 2.92643 11.3766 3.15147 11.1516C3.37652 10.9265 3.68174 10.8001 4 10.8001C4.31826 10.8001 4.62348 10.9265 4.84853 11.1516C5.07357 11.3766 5.2 11.6818 5.2 12.0001C5.2 12.3184 5.07357 12.6236 4.84853 12.8486C4.62348 13.0737 4.31826 13.2001 4 13.2001C3.68174 13.2001 3.37652 13.0737 3.15147 12.8486C2.92643 12.6236 2.8 12.3184 2.8 12.0001ZM12 10.8001C12.3183 10.8001 12.6235 10.9265 12.8485 11.1516C13.0736 11.3766 13.2 11.6818 13.2 12.0001C13.2 12.3184 13.0736 12.6236 12.8485 12.8486C12.6235 13.0737 12.3183 13.2001 12 13.2001C11.6817 13.2001 11.3765 13.0737 11.1515 12.8486C10.9264 12.6236 10.8 12.3184 10.8 12.0001C10.8 11.6818 10.9264 11.3766 11.1515 11.1516C11.3765 10.9265 11.6817 10.8001 12 10.8001Z'
					fill={pathFill}
				/>
			</g>
		</svg>
	);
};
